import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import Button from 'Components/UI/Button';
import { addSpacesBetweenWords } from 'Helpers/Formats';
import { fullDate } from 'Consts/DateFormats';
import moment from 'moment';
import { LIMIT, OFFSET, SORT } from 'Consts/queryParams';
import {
  CURRENCY,
  NUMBER,
  STRING,
  DATE,
  DATE_TIME,
  BOOL,
  PICKLIST,
  DOLLARS,
  PERCENT, MULTILINE,
} from 'Consts/meta';
import InputAdornment from '@material-ui/core/InputAdornment';

export default function getFieldName(template, name) {
  let def = template.filter(a => a.name === name);
  def = def.length ? def[0] : { options: [] };
  return def;
}

export const getFieldDefByName = (template, name) => {
  let def = (template || []).filter(a => a.name === name);
  def = def.length ? def[0] : { options: [] };
  return def;
};

export const getHidden = (template, name) => {
  const def = getFieldDefByName(template, name);
  return def.hidden;
};

export const getOptions = (template, name, defaultOptionText = '') => {
  const def = getFieldDefByName(template, name);
  const options = (def.options || []).map(o => ({
    id: o.id,
    value: addSpacesBetweenWords(o.prompt),
    depends: o.depends,
  }));

  options.unshift({ id: 0, value: defaultOptionText, depends: undefined });

  return options;
};

export const getPicklistPrompt = (field, value) => field.options.find(opt => opt.id === value).prompt || '';

export const hasOperator = (template, operator) => (template.operators
  ? template.operators.find(op => operator === op.id)
  : false);

export const formatDate = date => moment(new Date(date)).format(fullDate);

export const formatDollars = (value) => {
  const parsedValue = parseFloat(value);
  if (parsedValue % 1 === 0) {
    return `$${parsedValue.toFixed(0)}`;
  }
  return `$${parsedValue.toFixed(2)}`;
};

export const formatNumber = (value, metaField) => {
  switch (metaField.hint) {
    case DOLLARS:
      return formatDollars(value);
    default:
      if (metaField.precision && metaField.precision > 0) {
        return parseFloat(value).toFixed(metaField.precision);
      }
      return value;
  }
};

export const formatData = (resource, field, name, value, onChange) => {
  if (field.onClick) {
    return (
      <Button
        color="primary"
        onClick={() => field.onClick(resource, value)}
        variant="text"
      >
        {field.type === PICKLIST ? getPicklistPrompt(field, value) : value}
      </Button>
    );
  }

  switch (field.type) {
    case STRING || BOOL:
      return value;
    case DATE || DATE_TIME:
      return formatDate(value);
    case NUMBER:
      return formatNumber(value, field);
    case CURRENCY:
      if (field.precision && field.precision > 0) {
        const parsedValue = parseFloat(value);
        if (parsedValue % 10 === 0) {
          return `$${parsedValue.toFixed(0)}`;
        }
        return `$${parsedValue.toFixed(2)}`;
      }
      return `$${value}`;
    case PICKLIST:
      if (field.readonly) {
        return getPicklistPrompt(field, value);
      }

      return (
        <Select
          labelId="demo-simple-select-label"
          style={{ width: '100%' }}
          value={value}
          onChange={e => onChange(name, e.target.value)}
        >
          {field.options.map((opt, i) => (
            <MenuItem
              key={`menu-item.${i}`} // eslint-disable-line react/no-array-index-key
              value={opt.id}
            >
              {opt.prompt}
            </MenuItem>
          ))}
        </Select>
      );
    default:
      return value;
  }
};

export const isDefaultParam = param => param === LIMIT || param === OFFSET || param === SORT;

export const parseQueries = (queries) => {
  const quers = {};
  queries.forEach((query) => {
    query.template.forEach((template) => {
      quers[template.name] = template;
    });
  });
  return quers;
};

export const parseQueriesFromCollection = (collection) => {
  const quers = {};
  collection
    .meta()
    .queries()
    .list()
    .forEach((query) => {
      query
        .template()
        .list()
        .forEach((template) => {
          quers[template.attr('name')] = template;
        });
    });
  return quers;
};

export const getDependentOptions = (template, name, val) => {
  const def = getFieldDefByName(template, name);
  const options = (def.options || [])
    .filter(
      o => o.depends && o.depends.length && o.depends.some(v => v === val),
    )
    .map(o => ({
      id: `${o.id}`,
      prompt: o.prompt,
    }));
  options.unshift({ id: '0', prompt: '' });
  return options;
};

export const getMaterialInputPropsWithDefaults = (
  hint,
  { InputProps = {} },
) => {
  switch (hint) {
    case DOLLARS:
      return {
        ...InputProps,
      };
    case MULTILINE:
      return {
        multiline: true,
        rows: 5,
        ...InputProps,
      };
    case PERCENT:
      return {
        endAdornment: <InputAdornment position="start">%</InputAdornment>,
        ...InputProps,
      };
    default:
      return InputProps;
  }
};
